import freyaPic from "@/public/images/artists/freya.png";
import { Artist } from "@/types/types";

export const freya = {
  id: "125",
  name: "Freya",
  image: freyaPic,
  description: `Freya's voice is recognized by it's light, fluid delivery. Her vocal quality can be described as clear and expressive, with a moderate to bright tone that carries both warmth and clarity.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ffreya-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "RnB", "Ethereal"],
      secondary: ["Youthful"],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "High",
      },
      specific: {
        low: 57,
        high: 73,
      },
    },
  },
} as const satisfies Artist;
